// extracted by mini-css-extract-plugin
module.exports = {"page_row":"SingleServiceCenter_page_row__h2-Ri","page_section":"SingleServiceCenter_page_section__3n_EG","sidebar":"SingleServiceCenter_sidebar__2oo3t"};